module.exports = __webpack_public_path__ + "img/nickname-logo.69737983.png";